import { Component, OnInit } from '@angular/core';
import { UsersService, UserModel, CustomersService, CustomerRegisterCommand } from 'src/app/Api_Module';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { titles } from 'src/app/models/constants.model';

@Component({
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {

  user: CustomerRegisterCommand = {};
  loading: boolean;
  titles: string[];
  confirmPassword: string;

  constructor(private custServ: CustomersService, private router: Router, private toastr: ToastrService ) { }

  ngOnInit() {
    this.titles = titles.sort();
    this.user.title = null;
  }

  signUp(valid: boolean) {
    if (valid === true) {
      this.custServ.register(this.user).subscribe((resp) => {
        this.loading = false;
        const user: UserModel = resp;
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.toastr.success('Sign Up Success! Please Log in');
        this.router.navigate(['/login']);
      },
        error => {
          this.toastr.error('Sign Up Failed!');
          this.loading = false;
        });
    } else {
      this.toastr.warning('Invalid Inputs, please rectify');
    }
  }


}
